import api from '../api/orders'

const state = {
    SalesFunnelOrder: false,
    orderBumpState: false,
}

const getters = {
    getSalesFunnelOrder: state => {
        return state.SalesFunnelOrder
    },

    getOrderBumpState: state => {
        return state.orderBumpState
    }
}

const actions = {
    getSalesFunnelOrder({dispatch, commit}, slug) {
        return new Promise((resolve, reject) => {
            api.getSalesFunnelOrder(slug)
            .then((success) => {
                commit('setSalesFunnelOrder', success.items[0])
                return resolve(success)
            }).catch((failed) => {
                commit('setSalesFunnelOrder', false)
                return reject(failed)
            })
        })
    }
}



const mutations = {
    setSalesFunnelOrder(state, value) {
        let boxes = [];
        var allBoxes = [];
        allBoxes.push(value.fields.box1);
        if(value.fields.box2){
            allBoxes.push(value.fields.box2);
        }
        if(value.fields.box3){
            allBoxes.push(value.fields.box3);
        }
        if(value.fields.box4){
            allBoxes.push(value.fields.box4);
        }
        if(value.fields.box5){
            allBoxes.push(value.fields.box5);
        }
        if(value.fields.box6){
            allBoxes.push(value.fields.box6);
        }
        allBoxes.forEach(box =>{
            api.getOrderBox(box.sys.id)
                .then((data) => {
                    boxes.push(data)
                }).catch((failed) => {
            })
        })
        value.fields.boxes = boxes
        state.SalesFunnelOrder = value
    },

    setOrderBumpState(state, choice){
        state.orderBumpState = choice
    }
}
export default {
    state, getters, actions, mutations
}
